export default __webpack_public_path__ + "static/media/pto_icon.da9df916.svg";